import { Pipe, PipeTransform } from '@angular/core';
import { svgElement } from 'src/dictionaries/svg-sign';
import { SignalingTypeEnum, HorizontalSignalingEnum, ApplicationColorEnum } from 'src/enumerators';

@Pipe({ name: 'enumSvg' })
export class EnumSvgPipe implements PipeTransform {

  private normalizeColor(color: any): 'WHITE' | 'YELLOW' | undefined {
    if (color === ApplicationColorEnum.White || color === 'White' || color === 'WHITE' || color === 0) return 'WHITE';
    if (color === ApplicationColorEnum.Yellow || color === 'Yellow' || color === 'YELLOW' || color === 1) return 'YELLOW';
    return undefined;
  }

  transform(value: string, ...args: any[]): string {
    const dictKey = args[0];          // 'Signaling'
    const signType = args[1];         // SignalingTypeEnum.Horizontal / Vertical / Device
    const color = args[2];            // ApplicationColorEnum (opcional)

    if (!svgElement[dictKey]) return 'Enumerador Inválido';

    // default quando não tem value ou não existe no dicionário
    if (!value || !svgElement[dictKey][value]) {
      if (signType === SignalingTypeEnum.Vertical) return 'assets/icons/map-vertical.svg';
      if (signType === SignalingTypeEnum.Horizontal) return 'assets/icons/map-horizontal.svg';
      if (signType === SignalingTypeEnum.Device) return 'assets/icons/map-devices.svg';
    }

    // Regra LCO + cor (somente para Horizontal)
    if (
      dictKey === 'Signaling' &&
      signType === SignalingTypeEnum.Horizontal &&
      value === HorizontalSignalingEnum.LCO
    ) {
      const c = this.normalizeColor(color) || 'WHITE'; // <- default WHITE para os antigos

      if (c === 'WHITE') return 'assets/signalings/horizontal/LCO_WHITE.svg';
      if (c === 'YELLOW') return 'assets/signalings/horizontal/LCO_YELLOW.svg';
    }


    if (!svgElement[dictKey][value]) return (dictKey + ' Inválido');

    return svgElement[dictKey][value];
  }
}
